import { transformChemicalProductDatesToMoment } from '../../../Dates';
import Connector, { takeQuery } from '../../../agent';
import types from './types';
import { goToErrorPage } from '../../../utils';

const ChemicalProductsHistory = {
  getChemicalProductHistory: ({ id }) =>
    Connector.api.get(`/chemicalProducts/history/${id}`, false, {}),
  getInitialData: ({ id }) =>
    Connector.api.get(`/chemicalProducts/history/getInitialData/${id}`, false, {})
};

const chemicalProductsHistorySagas = [
  takeQuery(types.GET_CHEMICAL_PRODUCT_HISTORY, {
    api: ChemicalProductsHistory.getChemicalProductHistory,
    process: transformChemicalProductDatesToMoment,
    notifyFailure: [goToErrorPage]
  }),
  takeQuery(types.GET_CHEMICAL_PRODUCT_HISTORY_INITIAL_DATA, {
    api: ChemicalProductsHistory.getInitialData
  })
];

export default chemicalProductsHistorySagas;
